import { z } from "zod"
import { useForm } from "vee-validate"
import { toTypedSchema } from "@vee-validate/zod"
import { requiredTrimmedString } from "@/validation/sharedStringFieldSchemas"

const createRoleFormSchema = z.object({
  name: requiredTrimmedString("Role name is required").max(
    32,
    "Must be 32 characters or fewer"
  ),
  permissions: z
    .array(z.string())
    .min(1, "At least one permission must be selected"),
})

export const useCreateEditRoleForm = () =>
  useForm({
    validationSchema: toTypedSchema(createRoleFormSchema),
    initialValues: {
      name: "",
      permissions: [],
    },
  })
